<template>
  <section class="grid-flex column">
    <div class="box w100">
      <div class="box-title">
        Avaliação Profissional
      </div>
      <div class="box-content">
        <p>Nossa ferramenta faz uma análise profissional da sua loja para te indicar onde você precisa melhorar para vender ainda mais!</p>
        <p>Para ter seu relatório basta adicionar a url da sua loja abaixo e apertar o botão para enviar.</p>
        <div class="margin-top-l">
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(createRateStore)">
              <validation-provider
                  name="url da loja"
                  rules="required"
                  v-slot="{ errors }"
                >
                <div class="form-field" :class="{ errors: errors[0] }">
                  <label> Url da sua loja:</label>
                  <input type="text" placeholder="www.sualoja.com.br" v-model="newRate.url" />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <div class="action margin-top-l">
                <button class="button primary" type="submit">AVALIAR LOJA</button>
              </div>
            </form>
            </validation-observer>

        </div>
      </div>
    </div>
    <div class="margin-top-l">
      <h3>Últimas Avaliações:</h3>
    </div>

    <div v-if="ratestoreslist && ratestoreslist.length > 0 && !loading" class="grid-flex w100 column margin-top-l">
      <div v-for="(s, index) in ratestoreslist" :key="index" class="box w100 margin-top-s" style="margin-left:0px">
        <div class="box-content content-list">
          <div class="flex middle">
            <div class="score">
              <p v-if="s.status === 'DONE'">{{ s.score }}/10</p>
              <p v-else>X/10</p>
            </div>
            <div class="flex-2 ">
              <div class="url">
                <p>{{ s.url }}</p>
              </div>
              <div class="margin-top-s">
                <p v-if="s.status === 'DONE'">{{ s.sort_description}}</p>
                <p v-else><b>Estamos trabalhando na sua avaliação. Aguarde!!!</b></p>
              </div>
            </div>
            <div v-show="false" class="action">
              <div class="button primary">RELATÓRIO</div>
            </div>
            <div class="date-created">
              <small>{{ s.created_at | date }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!loading" class="grid-flex column margin-top-l">
      <p>Você não tem nenhuma avaliação. Crie a sua primeira que vamos adorar te ajudar!!!</p>
    </div>
    <div v-if="loading" class="w100">
      <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
    </div>

  </section>
</template>

<script>

import {
  getRateStores,
  createRatestore
} from "@/services/ratestore";

export default {
  name: "rate-store",
  components: {},
  data() {
    return {
      loading: false,
      newRate: {
        url: ''
      },
      ratestoreslist: []
    };
  },
  mounted() {
    this.getRateStores()
  },
  methods: {
    createRateStore() {
      let params = {
        url: this.newRate.url
      }
      createRatestore(params)
      .then((result) => {
        this.ratestoreslist.unshift(result)
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu um problema ao salvar avaliação'
        })
      })
    },
    getRateStores() {
      this.loading = true
      getRateStores()
        .then((result) => {
          this.ratestoreslist = result.ratestores
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao buscar informações'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.score {
  padding-right: 15px;
  margin-right: 20px;
  border-right: 1px solid var(--primary);
  font-size: 28px;
  font-weight: 800;
  color: var(--primary)
}

.content-list {
  position: relative;
  .date-created {
    position: absolute;
    right: 35px;
    top: 10px
  }
  .url {
    color: var(--primary);
  }
}
</style>
